import {Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {capitalizeFirstLetter} from '../../../utils/string-utils';

@Pipe({
    name: 'documentStatusName'
})
export class DocumentStatusNamePipe implements PipeTransform {
    constructor(private translocoService: TranslocoService) {
    }

    transform(status: string): string {
        const statusExists = (status ?? '').toString();
        const formattedStatus = capitalizeFirstLetter(statusExists?.trim())?.split('_')?.join(' ');
        return this.translocoService.translate(`Document - listview - status - ${formattedStatus}`) ?? formattedStatus;
    }

}
